<div class="form-control input">
<input
  id="txtDateInput"
  type="tel"
  spellcheck="false"
  name="calBirthDate"
  placeholder="dd/mm/aaaa"
  class="text-input inline text-09-d-demibold txtDate"
  [class.error]="validationUiService.isInsuredSubmit && !validationUiService.isPrimaryInsuredDob(contractType)"
  inputmode="numeric"
  [value]="DOB"
  appDateMask 
  (valueChange)="onSubmitAnswer($event)"
  (underageWarning)="underageWarning.emit($event)"/>
  
  <p
    id="error-date1"
    class="error-txt"
    [class.hidden]="!validationUiService.isInsuredSubmit || (validationUiService.isInsuredSubmit && validationUiService.isPrimaryInsuredDob(contractType))">
    {{ questionError }}
  </p>
</div>